module.exports = __webpack_public_path__ + "img/Forgot-Mail-BP.b24b8b9f.png";